<div class="vc-modal__innerContainer">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>

  <ng-container *ngIf="showForm">
    <div class="vc-modal__title" i18n="@@ALERT.MODAL.TITLE">Create an alert</div>

    <div class="vc-modal__content">
      <div class="alertModal__options">
        <div class="alertModal__options--column">
          <ng-container *ngIf="product.universe && product.universe.localizedName">
            <label class="vc__label" i18n="@@ALERT.MODAL.OPTIONS.UNIVERSE">Categories</label>
            <div class="vc__select">
              <select required aria-label="universe" name="universe" class="universe__select">
                <option>{{ product.universe.localizedName }}</option>
              </select>
            </div>
          </ng-container>

          <ng-container *ngIf="product.category && product.category.localizedName">
            <label class="vc__label" i18n="@@ALERT.MODAL.OPTIONS.CATEGORY">Product</label>
            <div class="vc__select">
              <select required aria-label="category" name="category" class="category__select">
                <option>{{ product.category.localizedName }}</option>
              </select>
            </div>
          </ng-container>

          <ng-container *ngIf="product.brand && product.brand.name">
            <label class="vc__label" i18n="@@ALERT.MODAL.OPTIONS.BRAND">Brand</label>
            <div class="vc__select">
              <select required aria-label="brand" name="brand" class="brand__select">
                <option>{{ product.brand.name }}</option>
              </select>
            </div>
          </ng-container>

          <ng-container *ngIf="product?.model && product?.model.localizedName">
            <label class="vc__label" i18n="@@ALERT.MODAL.OPTIONS.MODEL">Model</label>
            <div class="vc__select">
              <select required aria-label="model" name="model" class="model">
                <option>{{ product.model.localizedName }}</option>
              </select>
            </div>
          </ng-container>
        </div>

        <div class="alertModal__options--column">
          <ng-container *ngIf="sizeList">
            <label class="vc__label" i18n="@@ALERT.MODAL.OPTIONS.SIZE">Size / Shoe size</label>
            <div class="vc__select">
              <select required aria-label="size" name="size" class="size__select" [(ngModel)]="idSize">
                <option selected="selected" i18n="@@ALERT.MODAL.OPTIONS.ALL">all</option>
                <option *ngFor="let sizeRow of sizeList" [ngValue]="sizeRow.id">{{ sizeRow.label }}</option>
              </select>
            </div>
          </ng-container>

          <ng-container *ngIf="colorList">
            <label class="vc__label" i18n="@@ALERT.MODAL.OPTIONS.COLOR">Colour</label>
            <div class="vc__select">
              <select required aria-label="color" name="color" class="color__select" [(ngModel)]="idColor">
                <option selected="selected" i18n="@@ALERT.MODAL.OPTIONS.ALL">all</option>
                <option *ngFor="let color of colorList" [ngValue]="color.id">{{ color.label }}</option>
              </select>
            </div>
          </ng-container>

          <ng-container *ngIf="materialList">
            <label class="vc__label" i18n="@@ALERT.MODAL.OPTIONS.MATERIAL">Material</label>
            <div class="vc__select">
              <select required aria-label="material" name="material" class="material__select" [(ngModel)]="idMaterial">
                <option selected="selected" i18n="@@ALERT.MODAL.OPTIONS.ALL">all</option>
                <option *ngFor="let material of materialList" [ngValue]="material.id">{{ material.label }}</option>
              </select>
            </div>
          </ng-container>

          <ng-container *ngIf="patternList && showPatternSelect">
            <label class="vc__label" i18n="@@ALERT.MODAL.OPTIONS.PATTERN">Pattern</label>
            <div class="vc__select">
              <select required aria-label="pattern" name="pattern" class="pattern__select" [(ngModel)]="idPattern">
                <option selected="selected" i18n="@@ALERT.MODAL.OPTIONS.ALL">all</option>
                <option *ngFor="let pattern of patternList" [ngValue]="pattern.id">{{ pattern.label }}</option>
              </select>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <label class="vc__label" i18n="@@ALERT.MODAL.OPTIONS.LABEL">I would like to receive my alert:</label>
    <div class="vc__select">
      <select
        required
        aria-label="size"
        name="listAlertFrequency"
        class="size__select"
        [(ngModel)]="listAlertFrequency"
      >
        <option [ngValue]="'eachDay'" i18n="@@ALERT.MODAL.OPTIONS.SELECT.EVERY_DAY_MAIL">Every-day by email</option>
        <option [ngValue]="'emailAndPush'" i18n="@@ALERT.MODAL.OPTIONS.SELECT.NOW_MAIL_MOBILE"
          >Immediately, by email and mobile notification</option
        >
        <option [ngValue]="'email'" i18n="@@ALERT.MODAL.OPTIONS.SELECT.NOW_MAIL">Immediately, by email</option>
        <option [ngValue]="'push'" i18n="@@ALERT.MODAL.OPTIONS.SELECT.NOW_MOBILE"
          >Immediately, by mobile notification</option
        >
      </select>
    </div>

    <div class="alertModal__actionContainer">
      <button
        class="vc-btn vc-btn--primary vc-btn--medium"
        (click)="createAlert()"
        [disabled]="!listAlertFrequency"
        i18n="@@ALERT.MODAL.BTN_CREATE"
      >
        Confirm
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="showSuccess" i18n="@@ALERT.MODAL.ALERT_CREATED"
    >You have already created this alert.</ng-container
  >

  <ng-container *ngIf="showAlreadyExists" i18n="@@ALERT.MODAL.ALERT_ALREADY_EXISTS"
    >This alert has already been created.</ng-container
  >

  <ng-container *ngIf="showErrors">{{ errorMessage }}</ng-container>
</div>
